<template>
  <div class="leftCardContainer">
    <div class="rightSideTitleActions">
      <span class="leftTitle">{{ $tc('Role', 2) }}</span>
      <div class="actionsContainer">
        <div class="searchContainer">
          <v-icon> search </v-icon>
          <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
            borderRadius: '0px',
            width: '130px',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: '1px solid rgba(118, 118, 118, 0.50)',
          }" @input="handleSearch($event)" />
        </div>
        <CustomButton
          icon="delete"
          :width="'20px'"
          :height="'20px'"
          :iconSize="12"
          :disabled="
            (
              selectedItem &&
              Object.keys(selectedItem).length !== 0
                ? false
                : true
            ) ||
            !userHasPermission('role_destroy')
          "
          :buttonStyling="{
            padding: '8px',
            marginRight: '5px',
            borderRadius: '4px',
          }"
          @buttonClick="deleteDialogIsOpen = true"
        />
        <CustomButton icon="download" :width="'20px'" :height="'20px'" :iconSize="12"
          :disabled="true" :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleDownload" />
        <CustomButton icon="add" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" :disabled="!userHasPermission('role_store') || userIsCreatingOrEditingData" @buttonClick="handleAdd" />
      </div>
    </div>
    <div class="tabsContainer">
      <Tabs :activeTab="activeTab" :tabs="tabs" :center-tabs="false" @startTabChange="handleTabChange" />
    </div>
    <div class="tableDivContainer">
      <Table :checkbox="false" :loading="loading" :headers="headers" :items="roles" :sortable="true"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="true"
      />
    </div>
    <dialog-choice
      :isOpen="deleteDialogIsOpen"
      :title="$t('DeleteRole')"
      :content="$t('DeleteRoleDialog')"
      :mainActionLabel="$t('Confirm')"
      @mainAction="handleDelete"
      :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="deleteDialogIsOpen = false"
      icon="mdi-delete"
      iconColor="var(--app-primary-base)"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { companyListsMixin } from "@/mixins/management/companyListsMixin";
import { rolesListsMixin } from "@/mixins/management/rolesListsMixin";
import { canEditCompanyMixin } from "@/mixins/management/canEditCompanyMixin";
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import CustomButton from "@/newComponents/_Atoms/CustomButton.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import Tabs from "@/newComponents/_Atoms/Tabs.vue";
import DialogContent from "@/newComponents/_Molecules/DialogContent.vue";
import LoadingSpinner from "vue-loading-overlay";
import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "TableView",

  mixins: [managementDatatableMixin, companyListsMixin, rolesListsMixin, canEditCompanyMixin, checkPermissionsMixin],

  components: {
    Table,
    ManagementPage,
    CustomButton,
    InputField,
    Tabs,
    DialogContent,
    LoadingSpinner,
    DialogChoice,
  },

  props: {
    selectedItem: {
      type: Object,
    },
  },

  data() {
    return {
      dialog: false,
      deleteDialogIsOpen: false,
      value: null,
      type: "normal",
      search: null,
      activeTab: 0,
      loading: false,
      scrollTop: 0,
      sortOrder: null,
      scrollHeight: 0,
      tabs: [],
      pageNumber: 1,
      pagination: 25,
      currentPageTop: 1,
      currentPageBot: 1,
      lastPage: 2,
      roles: [],
      userIsCreatingOrEditingData: false,
    };
  },

  mounted() {
    this.getInitialRoles();
    this.getTabs();
    bus.$on("reload-roles", () => this.getInitialRoles())
    bus.$on("toggle-create-edit-flag", () => this.userIsCreatingOrEditingData = !this.userIsCreatingOrEditingData)
  },

  destroyed() {
    bus.$off("reload-roles");
    bus.$off("toggle-create-edit-flag");
  },

  computed: {
    headers() {
      return [
        { text: this.$i18n.t("Name"), varName: "name" },
        { text: this.$i18n.t("Description"), varName: "description" },
        { text: this.$i18n.tc("Company", 1), varName: "companyName" },
      ]
    },

  },

  methods: {
    ...mapActions([
      "fetchAllClientRolesParams",
      "fetchUserCompanies",
      "fetchAllCompanies",
      "fetchAllClientRoles",
      "deleteClientRoleByUuid",
      "GET_LIST"
    ]),

    closeDialog() {
      this.dialog = false;
    },

    async getTabs() {
      this.loading = true;
      try {
        const result = this.roleLevelOptions = await this.GET_LIST({
          listName: 'list_company_level'
        })

        const filteredTabs = result.map(tab => {
          return {
            label: tab.client_label,
          };
        });

        this.tabs = filteredTabs
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async handleDelete() {
      this.loading = true
      try {
        await this.deleteClientRoleByUuid(this.selectedItem.id)
        bus.$emit("clear-SelectedItems")
        this.$emit('clear-selected-item')
      } catch (error) {
        this.$toasted.global.toast_error(error.response.data.message);
        console.error(error);
      } finally {
        this.loading = false;
        this.getInitialRoles()
        this.deleteDialogIsOpen = false
      }
    },

    handleExtraAction() {
      this.handleDownload();
    },

    async handleDownload() {
      try {
        // TODO
      } catch (e) {
        console.error(e);
      }
    },

    async getInitialRoles() {
      this.loading = true;
      this.currentPageBot = 1
      this.currentPageTop = 1
      let queryParams = {
        "page[number]": 1,
        paginate: 25,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      if (this.activeTab !== null) {
        queryParams["filter[company_level]"] = `${this.activeTab + 1}`;
      }
      const roles = await this.fetchAllClientRolesParams(queryParams);
      this.roles = [...roles.data];
      this.lastPage = roles.meta.last_page;
      this.loading = false;
    },

    async getRolesBottom() {
      this.loading = true;
      this.pagination = 25;
      if (this.roles.length >= 75) {
        this.currentPageTop++;
      }
      this.currentPageBot++;

      let queryParams = {
        "page[number]": this.currentPageBot,
        paginate: this.pagination,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      if (this.activeTab !== null) {
        queryParams["filter[company_level]"] = `${this.activeTab + 1}`;
      }

      const rolesObject = await this.fetchAllClientRolesParams(queryParams);
      this.lastPage = rolesObject.meta.last_page;
      const allRoles = [...this.roles, ...rolesObject.data];
      this.roles = Array.from(new Set(allRoles.map(a => a.id)))
        .map(id => { return allRoles.find(a => a.id === id) })
      if (this.roles.length > 75) {
        this.roles = this.roles.slice(this.roles.length - 75);
      }

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 2; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll - offset,
            behavior: "smooth",
          });
        }
      }
    },

    async getRolesTop() {
      this.loading = true;
      this.pagination = 25;
      this.currentPageTop--;

      let queryParams = {
        "page[number]": this.currentPageTop,
        paginate: this.pagination,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      if (this.activeTab !== null) {
        queryParams["filter[company_level]"] = `${this.activeTab + 1}`;
      }

      const rolesObject = await this.fetchAllClientRolesParams(queryParams);
      this.lastPage = rolesObject.meta.last_page;
      const allRoles = [...rolesObject.data, ...this.roles];
      this.roles = Array.from(new Set(allRoles.map(a => a.id)))
        .map(id => { return allRoles.find(a => a.id === id) })
      if (this.roles.length > 75) {
        this.roles.splice(-(this.roles.length - 75));
        this.currentPageBot--;
      }

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 25; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll + offset,
            behavior: "smooth",
          });
        }
      }
    },

    handleSearch: _.debounce(function (event) {
      if (event === "") {
        this.search = null;
      } else {
        this.search = event;
      }
      this.roles = [];
      this.getInitialRoles();
    }, 1000),

    onScrollBottom() {
      if (this.currentPageBot !== this.lastPage) {
        this.pageNumber++;
        this.getRolesBottom();
      }
    },

    onScrollTop() {
      if (this.currentPageTop !== 1) {
        this.pageNumber--;
        this.getRolesTop();
      }
    },

    onSortClick(sortOrder, index) {
      this.roles = []
      if (sortOrder === "asc") {
        this.sortOrder = this.headers[index].varName;
      } else if (sortOrder === "desc") {
        this.sortOrder = `-${this.headers[index].varName}`;
      } else {
        this.sortOrder = sortOrder;
      }
      this.getInitialRoles();
    },

    handleAdd() {
      this.$emit('open-create-role-form')
    },

    handleTabChange(index) {
      this.activeTab = index;
      this.getInitialRoles();
    },
  },
};
</script>

<style scoped>
.searchContainer {
  display: flex;
  align-items: center;
}

.tableDivContainer {
  height: 87%;
  margin-top: 5px;
}

.tabsContainer {
  height: 8%;
  display: flex;
  margin-top: 5px;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  text-transform: uppercase;
}

.rightSideTitleActions {
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.buttons-container-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 20px;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid var(--app-primary-base);
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  /* 200% */
  text-transform: uppercase;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layer-search {
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 5px;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}

.span-custom {
  display: flex;
  padding: 0px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}

.tabs-custom {
  padding: 0px 20px;
}

.table-custom {
  height: 90%;
}

.table-buttons-custom {
  height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/SystemManagement/Roles/TableView.vue